// extracted by mini-css-extract-plugin
export default {"geofence":"geofence-map-marker_geofence__-NCaq","geofence-center":"geofence-map-marker_geofence-center__KKTiT"};